import type { ViewApi } from '@fullcalendar/core';
import type FullCalendar from '@fullcalendar/react';
import type { Dispatch, RefObject, SetStateAction } from 'react';
import { createContext, useMemo, useRef, useState } from 'react';
import type { TimelineSlot } from './types';

type AbsenceTimelineContextValue = {
  view: ViewApi | null;
  setView: Dispatch<SetStateAction<ViewApi | null>>;
  selectedSlot: TimelineSlot | null;
  setSelectedSlot: Dispatch<SetStateAction<TimelineSlot | null>>;
  calendarRef: RefObject<FullCalendar | null>;
};

const AbsenceTimelineContext =
  createContext<AbsenceTimelineContextValue | null>(null);

function AbsencesTimelineProvider({ children }: { children: React.ReactNode }) {
  const [view, setView] = useState<ViewApi | null>(null);
  const [selectedSlot, setSelectedSlot] = useState<TimelineSlot | null>(null);
  const calendarRef = useRef<FullCalendar | null>(null);
  const value = useMemo(
    () => ({
      view,
      setView,
      selectedSlot,
      setSelectedSlot,
      calendarRef,
    }),
    [view, selectedSlot],
  );

  return (
    <AbsenceTimelineContext.Provider value={value}>
      {children}
    </AbsenceTimelineContext.Provider>
  );
}

export { AbsencesTimelineProvider, AbsenceTimelineContext };
